import { initializeScript } from '@src/telemetry/integrations/provider-utils/initialize-script'

import { TelemetryIntegration } from '../telemetry-events.types'
import { TELEMETRY_DOMAINS } from '../telemetry-domains.constants'

export const StylightPixel: TelemetryIntegration = {
  config: {
    enabled: true,
    eventIdealTimeout: 1000,
    domain: TELEMETRY_DOMAINS.STYLIGHT_PIXEL,
  },
  initialize: async () => {
    await initializeScript({
      key: 'stylight_pixel',
      domain: TELEMETRY_DOMAINS.STYLIGHT_PIXEL,
      path: `/v1/st.min.js`,
    })
  },
}
